import type { EventCategory } from "@/types/ui";
import TileEntity from "./TileEntity";

class EventTileEntity extends TileEntity {
	public static readonly eventType: EventCategory | null = null;

	public get eventType(): EventCategory | null {
		// Returns static property.
		return (this.constructor as typeof EventTileEntity).eventType;
	}
}

export default EventTileEntity;
